import React, { createContext, PropsWithChildren, useContext } from 'react';

const InternalRouter = createContext(true);

export const InternalRouterProvider: React.FC<PropsWithChildren> = ({
	children = null
}) => <InternalRouter.Provider value>{children}</InternalRouter.Provider>;

export const useInternalRouter = (): boolean => {
	const context = useContext(InternalRouter);
	return Boolean(context);
};
